import { render } from "./SMSNotifications.vue?vue&type=template&id=56e3336e&scoped=true&ts=true"
import script from "./SMSNotifications.vue?vue&type=script&lang=ts"
export * from "./SMSNotifications.vue?vue&type=script&lang=ts"

import "./SMSNotifications.vue?vue&type=style&index=0&id=56e3336e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e3336e"]])

export default __exports__